"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _icon_wrapper = _interopRequireDefault(require("./icon_wrapper"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var MicrophoneBadgeIcon = /*#__PURE__*/function (_React$Component) {
  function MicrophoneBadgeIcon() {
    _classCallCheck(this, MicrophoneBadgeIcon);
    return _callSuper(this, MicrophoneBadgeIcon, arguments);
  }
  _inherits(MicrophoneBadgeIcon, _React$Component);
  return _createClass(MicrophoneBadgeIcon, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "microphone-badge-icon icon"
      }, /*#__PURE__*/_react["default"].createElement("svg", {
        viewBox: "0 0 200 200",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/_react["default"].createElement("g", {
        id: "Page-1",
        stroke: "none",
        fill: "none"
      }, /*#__PURE__*/_react["default"].createElement("g", {
        id: "badge_interview_me"
      }, /*#__PURE__*/_react["default"].createElement("circle", {
        id: "background",
        cx: "100",
        cy: "100",
        r: "99.4"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M119,38.6 L151.2,70.8 C151.6,71.2 151.9,71.7 152.1,72.2 C155.6,68 157.7,62.6 157.7,56.7 C157.7,43.2 146.7,32.2 133.2,32.2 C127.3,32.2 121.9,34.3 117.7,37.7 C118.2,37.9 118.7,38.2 119,38.6 Z",
        id: "Path",
        fillOpacity: "0.4",
        fill: "#FFFFFF"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M127.2,85.4 L104.6,62.8 C103.2,61.4 103.2,59 104.6,57.6 L104.7,57.5 C106.1,56.1 108.5,56.1 109.9,57.5 L132.5,80.1 C133.9,81.5 133.9,83.9 132.5,85.3 L132.4,85.4 C130.9,86.8 128.6,86.8 127.2,85.4 Z",
        id: "Path",
        fill: "#FFFFFF"
      }), /*#__PURE__*/_react["default"].createElement("polygon", {
        id: "Path",
        fill: "#FFFFFF",
        opacity: "0.7",
        points: "105.1 63.3 94.4 75.8 114.1 95.4 126.5 84.7"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M94.4,75.8 L48.2,129.6 C46.4,131.7 46.5,134.9 48.5,136.9 L53,141.4 C55,143.4 58.1,143.5 60.3,141.7 L114.1,95.5 L94.4,75.8 Z M82.2,115.5 C80.1,117.6 76.6,117.6 74.4,115.5 L74.3,115.4 C72.2,113.3 72.2,109.8 74.3,107.6 L85.4,96.5 C87.5,94.4 91,94.4 93.2,96.5 L93.3,96.6 C95.4,98.7 95.4,102.2 93.3,104.4 L82.2,115.5 Z",
        id: "Shape",
        fill: "#FFFFFF"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M109.9,57.6 L132.4,80.1 C132.7,80.4 132.9,80.7 133.1,81.1 C133.2,81.1 133.2,81.1 133.3,81.1 C137.9,81.1 142.1,79.9 145.8,77.7 C145.5,77.5 145.3,77.3 145,77.1 L112.8,44.9 C112.6,44.7 112.4,44.5 112.3,44.3 C110.1,47.9 108.9,52.2 108.9,56.7 C108.9,56.8 108.9,56.8 108.9,56.9 C109.2,57 109.6,57.3 109.9,57.6 Z",
        id: "Path",
        fillOpacity: "0.428239729",
        fill: "#FFFFFF"
      }), /*#__PURE__*/_react["default"].createElement("circle", {
        id: "Oval",
        fill: "#FFFFFF",
        cx: "89.1",
        cy: "100.8",
        r: "4"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M145.2,77.3 L112.9,45 C111.2,43.3 111.2,40.5 112.9,38.8 L113,38.7 C114.7,37 117.5,37 119.2,38.7 L151.5,71 C153.2,72.7 153.2,75.5 151.5,77.2 L151.4,77.3 C149.7,79 146.9,79 145.2,77.3 Z",
        id: "Path",
        fill: "#FFFFFF"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M142.8,37.7 C137.7,35.4 132,34.9 126.6,36.4 C124.3,37 125.2,40.6 127.5,40 C132,38.7 136.7,39 140.9,40.9 C143.1,41.9 145,38.6 142.8,37.7 L142.8,37.7 Z",
        id: "Path",
        fill: "#FFFFFF"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M53,141.3 L48.5,136.8 C48.2,136.5 47.9,136.1 47.7,135.8 L46.1,137.4 C44.9,138.6 44.9,140.6 46.1,141.9 L48.4,144.2 C49.6,145.4 51.6,145.4 52.9,144.2 L54.6,142.5 C54.1,142.2 53.5,141.8 53,141.3 Z",
        id: "Path",
        fill: "#FFFFFF",
        opacity: "0.7"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M134.8,150.4 C122.7,152.3 111.8,165.4 99,159.2 C94.8,157.2 91.4,154 87.1,152.2 C82.2,150.1 77.1,150.5 72.1,152.1 C66.1,154 60.1,157.8 53.6,157.4 C50.1,157.2 46.1,155.7 44.6,152.3 C43.2,149.1 44.3,144.8 48,143.8 C48,143.8 48.1,143.8 48.1,143.8 L46.3,142 C46.2,141.9 46.2,141.8 46.1,141.7 C39.8,144.6 40.2,153.8 45.8,157.7 C57.4,165.8 69.6,152.5 81.6,153.6 C87.9,154.2 92.4,159 97.8,161.7 C102.7,164.1 107.7,164.2 112.9,162.6 C119.5,160.6 125,156.3 131.6,154.2 C138.3,152 149.3,153.4 149.3,162.6 C149.3,164.3 152,164.4 152,162.6 C151.8,153.7 142.6,149.2 134.8,150.4 Z",
        id: "Path",
        fill: "#FFFFFF"
      })))));
    }
  }]);
}(_react["default"].Component);
var _default = exports["default"] = (0, _icon_wrapper["default"])(MicrophoneBadgeIcon);